
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const StartButton = styled(Button)({
    background: '#ec0b52', // Replace with the exact button color from your design
    borderRadius: '14px', // Adjust to match the design
    padding: '10px 30px', // Adjust to match the design
    textTransform: 'none', // Remove uppercase styling from buttons
    marginBottom: '20px', // Space below the button
    fontSize: '18px', // Adjust to match the design,
    fontWeight: 700, // Adjust to match the design
    transition: 'all 0.3s ease-in-out', // Add a smooth transition to the button
    '&:hover': {
        backgroundColor: '#ec0b52', // Adjust to match the design

    },
});

const PlayDemoButton = styled(Button)({
    background: 'transparent', // Replace with the exact button color from your design
    border: '2px solid #ec0b52', // Adjust to match the design
    borderRadius: '14px', // Adjust to match the design
    padding: '10px 30px', // Adjust to match the design
    textTransform: 'none', // Remove uppercase styling from buttons
    marginBottom: '20px', // Space below the button
    fontSize: '18px', // Adjust to match the design,
    fontWeight: 700, // Adjust to match the design
    transition: 'all 0.3s ease-in-out', // Add a smooth transition to the button
    '&:hover': {
        backgroundColor: 'transparent', // Adjust to match the design
    },
});

// Custom styled components
const SectionContainer = styled(Box)({
    textAlign: 'center',
    padding: '50px 0px', // Adjust padding to match your design
});

const FeatureCard = styled(Card)({
    maxWidth: 345, // Adjust the width of the cards
    margin: 'auto', // This centers the card in its Grid item
    boxShadow: 'none', // Remove shadow if you don't want it
    borderRadius: '20px', // Adjust the border radius
    boxShadow: '0 0 10px 2px #000135',
});

const FeatureIcon = styled(Box)({
    fontSize: '2.5rem', // Adjust the icon size
    marginBottom: '20px',
    textAlign: 'left',
});

const CardTitle = styled(Typography)({
    fontWeight: 'bold',
    fontSize: '1.25rem', // Adjust the title size
    marginBottom: '10px',
});

const Headline = styled(Typography)({
    color: '#333', // Replace with the exact color from your design
    marginBottom: '20px', // Adjust this value to match the design
    fontWeight: 'bold',
    // Include the font-family you need, assuming it's Roboto for this example
    fontFamily: '"Inter", sans-serif',
});

const Subheadline = styled(Typography)({
    color: '#666', // Replace with the exact color from your design
    marginBottom: '40px', // Adjust this value to match the design
    paddingRight: 65, // Adjust this value to match the design
    fontWeight: 400, // Adjust this value to match the design
});

const footerTop = {
    background: 'url(/footer.svg) no-repeat center center',
    padding: '60px 20px',
};

const footerStyles = {
    boxShadow: '0 0 10px 3px #020047' ,
    background: 'linear-gradient(354deg, #000139 20%, #000000 50%)',
    marginBottom: '130px',
    color: 'white',
    a: {
        color: 'white',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    '.footer-link': {
        mb: 1, // margin-bottom for each link
    },
    '.newsletter-signup': {
        p: 1, // padding
        mb: 1, // margin-bottom
    },
    '.privacy-policy': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 4, // margin-top
    },
};

export { SectionContainer, FeatureCard, FeatureIcon, CardTitle, Headline, Subheadline, StartButton, PlayDemoButton, footerTop, footerStyles };